import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsHellyhansenComponent } from './simple-icons-hellyhansen.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsHellyhansenComponent ],
    exports:      [ SimpleIconsHellyhansenComponent ],
    bootstrap:    []
})
export class SimpleIconsHellyhansenModule {}
